import React from 'react';

interface ChatBotModalProps {
  isOpen: boolean;
  onClose: () => void; // 모달을 닫는 함수를 prop으로 추가
  children: React.ReactNode;
}

const ChatBotModal: React.FC<ChatBotModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  const handleBackgroundClick = (e: React.MouseEvent) => {
    // 배경 클릭 시 모달을 닫음
    onClose();
  };

  const handleModalClick = (e: React.MouseEvent) => {
    // 모달 내용 클릭 시 이벤트 전파 방지
    e.stopPropagation();
  };

  return (
    <div
      className="fixed inset-0 flex justify-end items-center z-[999999] bg-black bg-opacity-50" // 배경 클릭을 위한 영역
      onClick={handleBackgroundClick}
    >
      <div
        className="relative shadow-xl w-[380px] rounded-2xl overflow-hidden mr-7"
        onClick={handleModalClick} // 모달 클릭 시에는 이벤트 전파 방지
      >
        {children}
      </div>
    </div>
  );
};

export default ChatBotModal;
